import { render } from "./CustomerPageFooter.vue?vue&type=template&id=1b5cce22&scoped=true"
import script from "./CustomerPageFooter.vue?vue&type=script&lang=js"
export * from "./CustomerPageFooter.vue?vue&type=script&lang=js"

import "./CustomerPageFooter.vue?vue&type=style&index=0&id=1b5cce22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5cce22"]])

export default __exports__